<template>
  <div class="xit-fb-tabs">
    <div class="fb-tabs-nav">
      <div
        :key="tab"
        v-for="tab in tabs"
        @click="currentTab = tab"
        :class="['tabs-nav-tab', { 'tabs-nav-tab--active': currentTab === tab }]"
      >
        {{ tab }}
      </div>
    </div>

    <div 
      class="fb-tabs-content"
      :style="{ height: tabContentHeight + 'px' }"
    >
      <div id="tabs-content-scrollbar">
      <keep-alive>
        <component :is="currentTabComponent"></component>
      </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import Elements from './Elements'
import Buttons from './Buttons'

export default {
  name: 'Tabs',
  components: {
    'tab-elements': Elements,
    'tab-buttons': Buttons,
  },
  
  data: () => ({
    tabContentHeight: null,
    currentTab: 'Elements',
    tabs: ['Elements', 'Buttons',]
  }),

  computed: {
    currentTabComponent () {
      return 'tab-' + this.currentTab.toLowerCase()
    },  
  },

  methods: {
    activate (type) {
      this.active = type 
    },

    handleScrollbar() {
      $('#tabs-content-scrollbar').niceScroll({
        cursorcolor: '#cddeed'
      })
    },

    handleTabContentHeight () {
      const offsetHeight = document.getElementById('xit-flow-builder').offsetHeight
      if (parseInt(offsetHeight, 10) <= 95) {
        this.tabContentHeight = 0
      } else {
        this.tabContentHeight = document.getElementById('xit-flow-builder').offsetHeight - 95
      }
    },    
  },

  mounted() {
    this.handleScrollbar()
    this.handleTabContentHeight()

    this.$nextTick(function() {
      window.addEventListener('resize', this.handleScrollbar)
      window.addEventListener('resize', this.handleTabContentHeight)
    })
  },

  beforeDestroy() { // eslint-disable-line
    const tabsContentScrollbarElement = $('#tabs-content-scrollbar')
    if (tabsContentScrollbarElement) {
      tabsContentScrollbarElement.getNiceScroll().remove()
    }

    window.removeEventListener('resize', this.handleScrollbar)
    window.removeEventListener('resize', this.handleTabContentHeight)
  }  
}
</script>

<style scoped>
.xit-fb-tabs {
  display: flex;
  flex-direction: column;
  margin: 0px;
  padding: 0px;
}
.fb-tabs-nav {
  display: flex;
  justify-content: flex-start;
}
.tabs-nav-tab {
  margin-bottom: -1px;
  margin-right: -1px;
  padding: 6px 14px;
  font-size: 0.85rem;
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
  background: #f0f0f0;
  cursor: pointer;
}
.tabs-nav-tab:hover {
  background: #e0e0e0;
}
.tabs-nav-tab.tabs-nav-tab--active {
  background: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
.fb-tabs-content {
  margin: 0px;
  padding: 0px;
}

/* Important for nicescroll */
#tabs-content-scrollbar {
  height: 100% !important;
}
.tabs-content-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px 6px;
}
</style>